import React from 'react'
import { Link } from 'react-router-dom'
import HeroCarousel from '../components/HeroCarousel'
import './Home.css'
import { useDocumentMeta } from '../seo/useDocumentMeta'

function Home() {
  useDocumentMeta()
  /*
  宽度：1920px
  高度：800px
  宽高比：2.4:1（1920:800）

  */

  // 轮播图片配置
  // 你可以在这里添加图片 URL，或者从后端 API 获取
  const carouselImages = [
    {
      // 高质量图片参数：
      // w_2560: 更大宽度（适配高分辨率屏幕），h_1067: 对应高度，c_limit: 保持比例不裁剪
      // q_90: 高质量（90%），dpr_auto: 自动适配 Retina 显示器（2x），f_auto: 自动格式（WebP）
      url: 'https://res.cloudinary.com/dmhl3ukf9/image/upload/w_2560,h_1067,c_limit,q_90,dpr_auto,f_auto/v1768080944/Untitled_design_1_keblrf.png',
      overlay: {
        title: 'Welcome to Plur',
        subtitle: 'Where intimacy meets design',
        cta: {
          text: 'Shop All',
          link: '/products'
        }
      }
    },
    {
      url: 'https://res.cloudinary.com/dmhl3ukf9/image/upload/w_2560,h_1067,c_limit,q_90,dpr_auto,f_auto/v1768083699/Untitled_design_3_vxhkqg.png',
      overlay: {
        title: 'Vibrators',
        subtitle: 'Thoughtfully designed for ultimate pleasure',
        cta: {
          text: 'explore',
          link: '/products?category=Vibrators'
        }
      }
    },
    { //https://res.cloudinary.com/dmhl3ukf9/image/upload/v1768084615/Gray_and_Black_Minimalist_Fashion_Style_Banner_1_uogn8n.png
     
      url: 'https://res.cloudinary.com/dmhl3ukf9/image/upload/w_2560,h_1067,c_limit,q_90,dpr_auto,f_auto/v1768084615/Gray_and_Black_Minimalist_Fashion_Style_Banner_1_uogn8n.png',
      overlay: {
        title: 'Sexy Lingerie',
        subtitle: 'Designed to feel as good as it looks',
        cta: {
          text: 'explore',
          link: '/products?category=Sexy Lingerie'
        }
      }
    }
  ]

  return (
    <div className="home">
      {/* 图片轮播 */}
      <HeroCarousel images={carouselImages} autoPlayInterval={5000} />

      <section className="categories">
        <h2>Categories</h2>
        <div className="categories-grid">
          <Link 
            to="/products?category=Vibrators"
            className="category-card"
            style={{
              backgroundImage: `url(https://res.cloudinary.com/dmhl3ukf9/image/upload/w_800,h_800,c_fill,q_auto,f_auto/v1768175061/pexels-shvetsa-5187485_sv78b8.png)`
            }}
          >
            <div className="category-card-overlay">
              <h3>Vibrators</h3>
            </div>
          </Link>
          <Link 
            to="/products?category=Sexy Lingerie"
            className="category-card"
            style={{
              backgroundImage: `url(https://res.cloudinary.com/dmhl3ukf9/image/upload/w_800,h_800,c_fill,q_auto,f_auto/O1CN014ZPI1j2D2sFE0u6J2__2219599668552-0-cib_tqdaec.jpg)`
            }}
          >
            <div className="category-card-overlay">
              <h3>Lingerie</h3>
            </div>
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home


// https://res.cloudinary.com/dmhl3ukf9/image/upload/v1768175061/pexels-shvetsa-5187485_sv78b8.png
 // https://res.cloudinary.com/dmhl3ukf9/image/upload/v1768176448/O1CN014ZPI1j2D2sFE0u6J2__2219599668552-0-cib_tqdaec.jpg
